import { DEFAULT_THUMBNAIL_SIZE } from './constants';

export async function getVimeoThumbnail(id: string): Promise<string> {
  const data = await fetch(`https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${encodeURI(id)}`);

  const awaitedJson = await data.json();

  if (!awaitedJson.thumbnail_url) {
    throw new Error('No thumbnail found');
  }

  return replaceVimeoThumbnailSize(awaitedJson.thumbnail_url);
}

export function replaceVimeoThumbnailSize(url: string): string {
  return url.replace(/_\d+x\d+/, `_${DEFAULT_THUMBNAIL_SIZE}`);
}
